import React from 'react';
import { FormattedMessage } from 'react-intl';
import { appNotification } from '../../containers/App/appNotification';
import { createLocalNotification } from '../../containers/App/utils';

const notification = createLocalNotification('Manager', {
    error: (
        <FormattedMessage
            id='front-app/Manager/Notification/Error:title'
            defaultMessage='Manager Error'
        />
    ),
    warning: (
        <FormattedMessage
            id='front-app/Manager/Notification/Warning:title'
            defaultMessage='Manager Warning'
        />
    ),
    info: (
        <FormattedMessage
            id='front-app/Manager/Notification/Info:title'
            defaultMessage='Manager Info'
        />
    ),
    success: (
        <FormattedMessage
            id='front-app/Manager/Notification/Info:title'
            defaultMessage='Manager Info'
        />
    ),
});

export const managerNotifications = {
    createdSuccessfully: notification.success(appNotification.texts.createdSuccessfully),
    updatedSuccessfully: notification.success(appNotification.texts.updatedSuccessfully),
    unknownError: (details?: JSX.Element | string) => (
        notification.error(appNotification.texts.unknownError(details))
    ),
};
